import { QUICK_ACTION_TARGET_TYPES } from "@observe-tech/utils";
import { fail, oneOf } from "../infra/validation";
import type { QuickAction } from "../types";

export const assertValidQuickAction = (action: QuickAction): void => {
  if (typeof action.id !== "string" || action.id.length === 0)
    fail("quickAction.id is required");
  if (typeof action.name !== "string")
    fail("quickAction.name must be a string");
  for (const step of action.steps) {
    if (typeof step.actionType !== "string" || step.actionType.length === 0)
      fail("quickAction step actionType is required");
    if (!(step.pauseDuration >= 0))
      fail("quickAction step pauseDuration must be >= 0");
    for (const target of step.targets ?? []) {
      oneOf(target.type, QUICK_ACTION_TARGET_TYPES, "quickAction target type");
      if (typeof target.machineId !== "number")
        fail("quickAction target machineId must be a number");
      if (typeof target.siteId !== "number")
        fail("quickAction target siteId must be a number");
    }
  }
};
